import { yupResolver } from '@hookform/resolvers/yup';
import { enqueueSnackbar } from 'notistack';
import React from 'react';
import { Resolver, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { handleError } from '../../../../shared/functions/handleError';
import { ITeamContributions } from '../../../../shared/interfaces/team-contributions/ITeamContributions';
import { AdminTeamContributionsService } from '../service';
import { teamContributionsSchema } from './TeamContributionsCreate';
import TeamContributionsForm from './TeamContributionsForm';

const TeamContributionsUpdate = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();
  const { handleSubmit, control, watch, setValue } =
    useForm<ITeamContributions>({
      resolver: yupResolver(
        teamContributionsSchema,
      ) as unknown as Resolver<ITeamContributions>,
      defaultValues: async () => {
        const response = await AdminTeamContributionsService.getSingle(
          Number(id),
        );
        return {
          ...response,
          userIds: response?.users?.map((user) => user?.id),
        } as ITeamContributions;
      },
    });

  const submitHandler = (formData: ITeamContributions) => {
    id &&
      AdminTeamContributionsService.update(formData, Number(id))
        .then((response) => {
          if (response) {
            navigate(-1);
            enqueueSnackbar(
              t('toasts.successfullyUpdated', { title: formData.name }),
              { variant: 'success' },
            );
          }
        })
        .catch(handleError);
  };
  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <TeamContributionsForm
        control={control}
        isUpdate
        watch={watch}
        setValue={setValue}
      />
    </form>
  );
};

export default TeamContributionsUpdate;
